var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-row',{staticClass:"text-center safety-measures"},[_c('vs-col',{staticClass:"w-full safety-measures-item safety-measures-heavy-header"},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }